
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/growth-dashboard",
      function () {
        return require("private-next-pages/growth-dashboard.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/growth-dashboard"])
      });
    }
  